import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders }  from '@angular/core';
import {
  APP_BASE_HREF,
  LocationStrategy, 
  HashLocationStrategy 
} from '@angular/common';
import { HomeComponent } from 'test/views/home/home-component';
import { GlobalErrorHandler } from 'source/app/controls/services/logging/global-error-handler';
import { MessageToast } from 'test/views/home/toast/message-toast';
import { WelcomeComponent } from 'test/views/home/welcome/welcome-component';
import { TreeComponent } from 'test/views/home/tree/tree-component';
import { TooltipComponent } from 'test/views/home/tool-tip/tool-tip-component';
import { ToolbarComponent } from 'test/views/home/toolbar/toolbar-component';
import { ToastComponent } from 'test/views/home/toast/toast-component';
import { TextBoxComponent } from 'test/views/home/text-box/text-box-component';
import { TabsComponent } from 'test/views/home/tabs/tabs-component';
import { SwitchComponent } from 'test/views/home/switch/switch-component';
import { SliderComponent } from 'test/views/home/slider/slider-component';
import { SidenavComponent } from 'test/views/home/sidenav/sidenav-component';
import { SidebarComponent } from 'test/views/home/sidebar/sidebar-component';
import { RadioButtonComponent } from 'test/views/home/radio-button/radio-button-component';
import { PrimitivesComponent } from 'test/views/home/primitives/primitives-component';
import { PanelsComponent } from 'test/views/home/panels/panels-component';
import { ModalsComponent } from 'test/views/home/modals/modals-component';
import { MenuComponent } from 'test/views/home/menu/menu-component';
import { ListBoxComponent } from 'test/views/home/list-box/list-box-component';
import { Layout15Component } from 'test/views/home/layout/layout-15-component';
import { Layout14Component } from 'test/views/home/layout/layout-14-component';
import { Layout13Component } from 'test/views/home/layout/layout-13-component';
import { Layout12Component } from 'test/views/home/layout/layout-12-component';
import { BarComponent } from 'test/views/home/bar/bar-component';
import { BreadcrumbComponent } from 'test/views/home/breadcrumb/breadcrumb-component';
import { BusyIndicatorsComponent } from 'test/views/home/busy-indicators/busy-indicators-component';
import { ButtonsComponent } from 'test/views/home/buttons/buttons-component';
import { CardsComponent } from 'test/views/home/cards/cards-component';
import { ChartsComponent } from 'test/views/home/charts/charts-component';
import { CheckBoxComboBoxComponent } from 'test/views/home/check-box-combo-box/check-box-combo-box-component';
import { CheckBoxComponent } from 'test/views/home/check-box/check-box-component';
import { CheckBoxListBoxComponent } from 'test/views/home/check-box-list-box/check-box-list-box-component';
import { ComboBoxComponent } from 'test/views/home/combo-box/combo-box-component';
import { ContextMenuComponent } from 'test/views/home/context-menu/context-menu-component';
import { DevPlaygroundComponent } from 'test/views/home/dev-playground/dev-playground-component';
import { ExpanderComponent } from 'test/views/home/expander/expander-component';
import { FormControlsComponent } from 'test/views/home/form-controls/form-controls-component';
import { GraphComponent } from 'test/views/home/graph/graph-component';
import { GridComponent } from 'test/views/home/grid/grid-component';
import { IconsComponent } from 'test/views/home/icons/icons-component';
import { LayoutComponent } from 'test/views/home/layout/layout-component';

const appRoutes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { 
    path: 'home', 
    component:  HomeComponent,
    children: [
      { path: '', redirectTo: 'welcome', pathMatch: 'full'},
      { path: 'welcome', component: WelcomeComponent },
      { path: 'bar', component: BarComponent },
      { path: 'breadcrumb', component: BreadcrumbComponent },
      { path: 'busy-indicators', component: BusyIndicatorsComponent },
      { path: 'buttons', component: ButtonsComponent },
      { path: 'cards', component: CardsComponent },
      { path: 'check-box', component: CheckBoxComponent },
      { path: 'check-box-combo-box', component: CheckBoxComboBoxComponent },
      { path: 'check-box-list-box', component: CheckBoxListBoxComponent },
      { path: 'charts', component: ChartsComponent },
      { path: 'combo-box', component: ComboBoxComponent },      
      { path: 'context-menu', component: ContextMenuComponent },
      { path: 'dev-playground', component: DevPlaygroundComponent },
      { path: 'expander', component: ExpanderComponent },
      { path: 'form-controls', component: FormControlsComponent },      
      { path: 'graph', component: GraphComponent },
      { path: 'grid', component: GridComponent },
      { path: 'icons', component: IconsComponent },
      { path: 'layout', component: LayoutComponent },
      { path: 'list-box', component: ListBoxComponent },
      { path: 'menu', component: MenuComponent },      
      { path: 'modals', component: ModalsComponent },
      { path: 'panels', component: PanelsComponent },
      { path: 'primitives', component: PrimitivesComponent },
      { path: 'radio-button', component: RadioButtonComponent },
      { path: 'sidebar', component: SidebarComponent },
      { path: 'sidenav', component: SidenavComponent },
      { path: 'slider', component: SliderComponent },
      { path: 'switch', component: SwitchComponent },
      { path: 'tabs', component: TabsComponent },
      { path: 'text-box', component: TextBoxComponent },
      { path: 'toast', component: ToastComponent },
      { path: 'toolbar', component: ToolbarComponent },
      { path: 'tool-tip', component: TooltipComponent },
      { path: 'tree', component: TreeComponent },
    ]  
  },
];

export const appRoutingProviders: any[] = [
  { provide: LocationStrategy, useClass: HashLocationStrategy },
  //{ provide: APP_BASE_HREF, useValue: '/' },
]; 

export const routing: ModuleWithProviders =
RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/app-routing.ts